import {
	Card,
	Row,
	Col,
	Button,
	Image,
	Modal,
	Form
} from 'react-bootstrap'
import Link from 'next/link'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faPaperPlane, faShare } from '@fortawesome/free-solid-svg-icons'
import JobDescription from './JobDescription'
import styles from '../styles/JobDetails.module.scss'
import { useRouter } from 'next/router'
import { useTranslation } from 'react-i18next'
import { useState, useContext, useEffect } from 'react'
import ShareButton from './ShareButton'
import UserContext from '../UserContext'
import { createClient } from 'graphqurl'
import { SuccessApplyModal } from './ApplyJobModal'
import { PdpaAlertModal, PdpaFormModal } from './PdpaModal'
import axios from 'axios'

const JobDetails = ({ job, isFullPage }) => {
	const router = useRouter()
	const locale = router.locale
	const isApply = router.query.apply === 'true'
	const data = {
		id: job.id,
		companyName: job.Company.name,
		jobTitle: job.title
	}

	const getMapAddress = (): string => {
		if (job.JobLocations.length > 0) {
			return job.JobLocations[0]?.Branch?.Address.streetAddress
		} else {
			return ''
		}
	}

	const [isApplied, setIsApplied] = useState(false)
	const [isLoading, setIsLoading] = useState(false)
	const { user }: any = useContext(UserContext)
	const [mapAddress, setMapAddress] = useState(getMapAddress())
	const [allJobAddress] = useState(job.JobLocations)
	const [filteredJobAddress, setFilteredJobAddress] = useState(job.JobLocations)
	const [showShare, setShowShare] = useState(false)
	const [showSuccessModal, setShowSuccessModal] = useState(false)
	const [pdpa, setPdpa] = useState(false)
	const [showPdpaForm, setShowPdpaForm] = useState(false)
	const [showNSField, setShowNSField] = useState(false)
	const [addressInvalid, setAddressInvalid] = useState(false)
	const [token, setToken] = useState<any>('')
	const [profile, setProfile] = useState<any>(null)
	const [eventId, setEventId] = useState<any>('')
	const [pdpaData, setPdpaData] = useState({
		name: '',
		nric: '',
		address: '',
		blockNumber: '',
		streetName: '',
		unit: '',
		dateOfUnemployment: '',
		dateOfBirth: '',
		race: '',
		nsStatus: ''
	})
	const [address, setAddress] = useState({
		postalCode: '',
		streetAddress: '',
		location: {}
	})

	useEffect(() => {
		setEventId(router.query.event !== undefined ? parseInt(router.query.event as string) : 0)
	  setToken(localStorage.getItem('token'))
	  setProfile(JSON.parse(localStorage.getItem('profile') as string))
	}, [router.query.event])

	const client = createClient({
		endpoint: process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT as string,
		headers: {
			authorization: token ? `Bearer ${token}` : ''
		}
	})

	const { t } = useTranslation()

	const slugify = (str) => {
		const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
		const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------'
		const p = new RegExp(a.split('').join('|'), 'g')

		return str.toString().toLowerCase()
			.replace(/\s+/g, '-') // Replace spaces with -
			.replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
			.replace(/&/g, '-and-') // Replace & with 'and'
			.replace(/[^\w\-]+/g, '') // Remove all non-word characters
			.replace(/\-\-+/g, '-') // Replace multiple - with single -
			.replace(/^-+/, '') // Trim - from start of text
			.replace(/-+$/, '') // Trim - from end of text
	}

	const getSalTyp = (val) => {
		switch (val) {
		case 'PER DAY':
			return t('root.day')
		case 'PER HOUR':
			return t('root.hour')
		case 'PER MONTH':
			return t('root.month')
		case 'PER WEEK':
			return t('root.week')
		default:
			return t('root.month')
		}
	}

	const getJobTypeText = (jt) => {
		return (jt === 'FT' ? t('job_descrip.ft') : (jt === 'PT' ? t('job_descrip.pt') : t('job_descrip.con')))
	}

	const filterJobAddress = (e: any): void => {
		setFilteredJobAddress(job.JobLocations.filter((jl: any) => {
			return jl.Branch.Address.streetAddress.toUpperCase().indexOf(e.target.value.toUpperCase()) !== -1
		}))
	}

	const retrieveAddress = (postalCode: string): void => {
		axios.post(process.env.NEXT_PUBLIC_ADDRESS_SEARCH as string,
			{
				query: postalCode
			}, {
				headers: { 'Content-Type': 'application/json' }
			}).then((res) => {
			if (res.data === '') {
				setAddressInvalid(true)
				setAddress({
					postalCode: '',
					streetAddress: '',
					location: {}
				})
			} else {
				const { trimAddress, longitude, latitude } = res.data
				setAddressInvalid(false)
				setAddress({
					postalCode: postalCode,
					streetAddress: trimAddress as string,
					location: { type: 'Point', crs: { type: 'name', properties: { name: 'urn:ogc:def:crs:EPSG::4326' } }, coordinates: [longitude, latitude] }
				})
			}
		}).catch(() => null)
	}

	const checkIsRequiredICMS = (): void => {
		if (token === null || token === '') {
			router.push(`/login?redirect=/job/${slugify(job.title)}-${job.id as string}${eventId !== 0 ? `?event=${eventId.toString()}` : ''}`).catch(() => null)
		} else if (job.eventID === null && (job.isRequiredICMS === false || job.isRequiredICMS === null) && parseInt(process.env.NEXT_PUBLIC_REQUIRED_ICMS as string) === 0) {
			applyingJob()
		} else {
			client.query({
				query: `
          query {
            Applicant_by_pk(id: ${profile.id as number}) {
              name
              nationality
              address
              dateOfBirth
              nric
              race
              gender
              nsStatus
              isEmployed
              employmentStatus
              unemploymentDate
              Address {
                postalCode
                blockNumber
                unit
                streetAddress
              }
            }
            ApplicantEventQuestionAnswer_aggregate(where: {applicant: {_eq: ${profile.id as number}}}) {
              aggregate {
                count
              }
            }
            EventQuestionJoin_aggregate(where: {event: {_eq: ${job.eventID as number}}}) {
              aggregate {
                count
              }
            }
          }
        `
			}).then(({ data: { Applicant_by_pk: Applicant, ApplicantEventQuestionAnswer_aggregate: AA, EventQuestionJoin_aggregate: EA } }) => {

				if ((Applicant.address === null || Applicant.dateOfBirth === null || Applicant.nric === null || Applicant.race === null || (Applicant.nsStatus === null && Applicant.gender === 'MALE')) && ((job.eventID !== null && job.Event?.isYellowForm === true) || job.isRequiredICMS === true || parseInt(process.env.NEXT_PUBLIC_REQUIRED_ICMS as string) === 1)) {
					setPdpaData({
						name: Applicant.name,
						nric: Applicant.nric,
						address: Applicant.Address !== null ? Applicant.Address.postalCode : '',
						blockNumber: Applicant.Address !== null ? Applicant.Address.blockNumber : '',
						streetName: Applicant.Address !== null ? Applicant.Address.streetAddress : '',
						unit: Applicant.Address !== null ? Applicant.Address.unit : '',
						dateOfUnemployment: Applicant.unemploymentDate !== null ? Applicant.unemploymentDate : '',
						dateOfBirth: Applicant.dateOfBirth,
						race: Applicant.race,
						nsStatus: Applicant.nsStatus
					})
					setPdpa(true)
					if (Applicant.gender === 'MALE') setShowNSField(true)
					else setShowNSField(false)
				} else {
					if (eventId !== 0) {
						// Check for event QA
						if (AA.aggregate.count < EA.aggregate.count) {
							router.push(`/event/${eventId.toString()}/qna`).catch(() => null)
						} else {
							applyingJob()
						}
					} else {
						applyingJob()
					}
				}
			})
		}
	}

	const applyingJob = (): void => {
		const obj: any = {
			job: job.id,
			applicant: user.id,
			remarks: 'WEB',
			source: process.env.NEXT_PUBLIC_SITE_NAME === 'findjobs' ? 'WEB_FINDJOBS' : 'WEB_NTUC'
		}

		client.query({
			query: `
	        mutation($obj: [JobApplicant_insert_input!]!) {
	          insert_JobApplicant(objects: $obj) {
	            affected_rows
	          }
	        }
	      `,
			variables: {
				obj: obj
			}
		}).then(() => {
			setShowSuccessModal(true)
			setIsApplied(true)
		})
	}

	useEffect(() => {
		if(isApply) {
			checkIsRequiredICMS()
		}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isApply])

	useEffect(() => {
		if (pdpaData.address.length === 6) {
			retrieveAddress(pdpaData.address)
		}
	}, [pdpaData.address])

	useEffect(() => {
		setIsLoading(true)
		const checkIsApplied = async () => {
			if(token) {
				const hasuraQuery = client.query({
					query: `
						query {
							JobApplicant_aggregate (where: {
								applicant: {
									_eq: ${user.id}
								}
								job : {
									_eq: ${job.id}
								}
							}) {
								aggregate {count}
							}
						}
						`
				})

				const hasuraRes = await hasuraQuery
				const { data: { JobApplicant_aggregate } } = hasuraRes
				const aggregate = JobApplicant_aggregate?.aggregate?.count ? JobApplicant_aggregate?.aggregate?.count : 0

				if(aggregate !== 0) {
					setIsApplied(true)
				} else {
					setIsApplied(false)
				}
			}
		}

		checkIsApplied()
		setIsLoading(false)
	}, [client, job.id, token, user])


	// Apply job floating button for mobile
	const [showApplyNow, setShowApplyNow] = useState(false)
	useEffect(() => {
		const onScroll = () => {
			if(window.pageYOffset > 160) {
				setShowApplyNow(true)
			} else {
				setShowApplyNow(false)
			}
		}
		// clean up code
		window.removeEventListener('scroll', onScroll)
		window.addEventListener('scroll', onScroll, { passive: true })
		return () => window.removeEventListener('scroll', onScroll)
	}, [router.isReady, setShowApplyNow])


	return (
		<>
			<Card className={styles.jobDetailCard}>
				<Card.Body className='px-md-5 pt-4'>
					<Row className='pb-2 align-items-center'>
						{
							!isLoading && (
								<Col>
									<Row className='align-items-center'>
										<Col>
											<div>
												{!isApplied ? (
													<Button
														className={`${styles.btn_pl_pr} text-white fw-bold ${styles.block_on_mobile}`}
														onClick={checkIsRequiredICMS}
													>
														{/* {t('job_descrip.apply')} */}
														<FontAwesomeIcon icon={faPaperPlane} /> &nbsp;&nbsp;
														{t('job_descrip.apply')} Now
													</Button>
												) : (
													<Button
														disabled={true}
														variant='outline-primary'
														className={`fw-bold ${styles.block_on_mobile}`}
													>
														{/* {t('job_list.Applied')} */}
														<FontAwesomeIcon icon={faCheckCircle} /> &nbsp;
														You&apos;ve applied to this jobs
													</Button>
												)} &nbsp;&nbsp;&nbsp;
												{!isFullPage && <Link href={`/${locale}/job/${slugify(job.title)}-${job.id}`} passHref>
													<a target='_blank' className='text-decoration-none mt-2 view-in-new-tab' style={{ display: 'inline-block' }}>{t('job_list.View_in_new_tab')}</a>
												</Link>}
											</div>
										</Col>
										<Col className={styles.shareBtn} lg='auto'>
											<div>
												<Button variant='link' onClick={() => { setShowShare(true) }} className='text-decoration-none'>
													<FontAwesomeIcon icon={faShare} /> &nbsp; {t('root.share')}
												</Button>
											</div>
										</Col>
									</Row>
								</Col>
							)
						}
					</Row>
					<hr className={styles.separator} />
					<Row>
						<Col>
							{job.Company.avatar && <Image src={job.Company.avatar} alt='astons' className='mt-3 mb-2' />}
							<p className='mt-3 mb-0'>{job.title}</p>
							<small>{job.Company.name}</small>
							<div className='mt-1 mb-3'>
								<small>
									{!job.hideSalaries && job.JobSalaries.map((js, i) => {
										return (
											<span key={i}><strong />
												<span key={i}>
													<small>{getJobTypeText(js.jobType)}</small>:
													<span className={styles.salaryText}>
														{js.min > 0 ? ` ${router.locale?.toUpperCase() === 'SG' ? '$' : router.locale?.toUpperCase() === 'MY' ? 'RM' : '$'} ${js.min}` : ''}
														{js.min > 0 && js.max > 0 ? ' - ' : ''}
														{js.max > 0 ? ` ${router.locale?.toUpperCase() === 'SG' ? '$' : router.locale?.toUpperCase() === 'MY' ? 'RM' : '$'} ${js.max}` : ''}
													</span>
													<small> / {js.salaryType === null ? t('root.month') : getSalTyp(js.salaryType)}</small>
													{(js.jobType === 'CONTRACT') &&
														<small>, {js?.Enum_ContractLength?.label
														}
														</small>
													}
												</span>
											</span>
										)
									})}
								</small>
							</div>
						</Col>
					</Row>
					{(job.openToPWD || job.openToSenior) && <hr className={styles.separator} />}
					{(job.openToPWD || job.openToSenior) && (
						<div className='mb-3'>
							{job.openToSenior && <>{t('job_list.This_Job_is')} <strong>{t('job_list.Senior')}</strong> {t('job_list.Friendly')}<br/></>}
							{job.openToPWD && <>{t('job_list.This_Job_is')}  <strong>{t('job_list.PWD')}</strong> {t('job_list.Friendly')}</>}
						</div>
					)}
					{(job.vacancies != '' && job.vacancies !== null) && <hr className={styles.separator} />}
					{(job.vacancies != '' && job.vacancies !== null) && <Row>
						<Col>
							<small><strong>{t('job.vacancy')}: {job.vacancies}</strong></small>
						</Col>
					</Row>}
					<hr className={styles.separator} />
					<Row>
						<Col>
							<JobDescription job={job} />
						</Col>
					</Row>
					{job.Mrt.length > 0 && <hr className={styles.separator} />}
					{(allJobAddress.length > 0 || job.Mrt.length > 0 || job.City.length > 0) &&
						<Row>
							<Col>
								{(job.Mrt.length > 0 || job.City.length > 0) && <p><strong>{t('job.work_location')} ({locale?.toUpperCase() === 'SG' ? 'MRT' : locale?.toUpperCase() === 'MY' ? 'City' : 'MRT'})</strong></p>}

								{/* Show city location */}
								{(job.City.length > 0 && job.City.length < 10 && locale?.toUpperCase() === 'MY') && (
									job.City.map((city: any) => {
										return <Button className='text-white' variant='secondary' size='sm' key={city?.City?.id} style={{ border: 'none', marginRight: '5px', fontSize: '12px', marginBottom: '5px'}}>{city?.City?.name}</Button>
									})
								)}
								{(job.City.length > 0 && job.City.length > 10) && (
									<Button size='sm' style={{ backgroundColor: '#ee3325', marginRight: '5px' }}>Multiple Cities</Button>
								)}

								{/* Show mrt location */}
								{(job.Mrt.length > 0 && job.Mrt.length < 10 && locale?.toUpperCase() === 'SG') && (
									job.Mrt.map((mrt: any) => {
										return <Button className='text-white' size='sm' key={mrt?.MrtStation?.id} style={{ backgroundColor: mrt?.MrtStation?.MrtLine.colour, border: 'none', marginRight: '5px', fontSize: '12px', marginBottom: '5px'}}>{mrt?.MrtStation?.name} ({mrt?.MrtStation?.mrtLine})</Button>
									})
								)}
								{(job.Mrt.length > 0 && job.Mrt.length > 10) && (
									<Button size='sm' className='text-white' style={{ backgroundColor: '#ee3325', marginRight: '5px' }}>Islandwide</Button>
								)}

								{allJobAddress.length > 0 && <hr className={styles.separator} />}
								<br />
								{allJobAddress.length > 0 && (
									<>
										<p><strong>{t('job.work_location')}</strong></p>
										<Row>
											<Col>
												<Form.Control
													className='mb-3'
													type='text'
													placeholder={t('job.search_work_location')}
													onChange={(e: any) => {
														filterJobAddress(e)
													}}
												/>
												{filteredJobAddress.length > 0 ?
													<div className={styles.addressContainer}>
														{filteredJobAddress.map((ja: any, i: number) => {
															if(ja?.Branch !== null) {
																return (
																	<div
																		key={i} onClick={() => {
																			setMapAddress(ja?.Branch?.Address.streetAddress)
																		}}
																	>
																		<small style={ja?.Branch?.Address.streetAddress === mapAddress ? { fontWeight: 600 } : {}}>{ja?.Branch?.Address.streetAddress}, {ja?.Branch?.Address.postalCode}</small>
																		<hr />
																	</div>
																)
															}
														})}
													</div>
													:
													<div className='text-center mt-3'>
														<p>Work Location not available</p>
													</div>
												}
											</Col>
											<Col md={6} className='mt-3 mt-md-0'>
												{
													(mapAddress !== '' && mapAddress !== undefined) && (
														<iframe src={`https://www.google.com/maps/embed/v1/place?key=${process.env.NEXT_PUBLIC_GOOGLE_MAPS_KEY as string}&q=${mapAddress}`} width='100%' height='450' style={{ border: '0' }} allowFullScreen={false} loading='lazy' />
													)
												}
											</Col>
										</Row>
									</>
								)}
							</Col>
						</Row>}
					<hr className={styles.separator} />
					<Row className='align-items-center'>
						<Col>
							<div className='d-none d-sm-block'>
								{!isApplied ? (
									<Button
										className={`${styles.btn_pl_pr} text-white fw-bold ${styles.block_on_mobile}`}
										onClick={checkIsRequiredICMS}
									>
										{/* {t('job_descrip.apply')} */}
										<FontAwesomeIcon icon={faPaperPlane} /> &nbsp;&nbsp;
										{t('job_descrip.apply')} Now
									</Button>
								) : (
									<Button
										disabled={true}
										variant='outline-primary'
										className={`fw-bold ${styles.block_on_mobile}`}
									>
										{/* {t('job_list.Applied')} */}
										<FontAwesomeIcon icon={faCheckCircle} /> &nbsp;
										You&apos;ve applied to this jobs
									</Button>
								)} &nbsp;&nbsp;&nbsp;
								{!isFullPage && <Link href={`/${locale}/job/${slugify(job.title)}-${job.id}`} passHref>
									<a target='_blank' className='text-decoration-none mt-2 view-in-new-tab' style={{ display: 'inline-block' }}>{t('job_list.View_in_new_tab')}</a>
								</Link>}
							</div>
						</Col>
						<Col className={styles.shareBtn} lg='auto'>
							<div>
								<Button variant='link' onClick={() => { setShowShare(true) }} className='text-decoration-none'>
									<FontAwesomeIcon icon={faShare} /> &nbsp; {t('root.share')}
								</Button>
							</div>
						</Col>
					</Row>
				</Card.Body>
			</Card>
			<Modal show={showShare} onHide={() => { setShowShare(false) }} size='lg'>
				<Modal.Body className='text-center'>
					<br />
					<p className='fw-bolder'>{t('job_list.Share_this_job_with_your_friends')}</p>
					<div className={styles.shareBtn} >
						<ShareButton title={job.title} url={`${process.env.NEXT_PUBLIC_DOMAIN}/${locale}/job/${slugify(job.title)}-${job.id}`} />
					</div>
					<br />
				</Modal.Body>
			</Modal>
			<SuccessApplyModal
				show={showSuccessModal}
				setShowModal={setShowSuccessModal}
				data={data}
			/>
			<PdpaAlertModal
				show={pdpa}
				setShowModal={setPdpa}
				job={job}
				setShowPdpaForm={setShowPdpaForm}
			/>
			<PdpaFormModal
				show={showPdpaForm}
				setShowPdpaForm={setShowPdpaForm}
				pdpaData={pdpaData}
				setPdpaData={setPdpaData}
				showNSField={showNSField}
				address={address}
				addressInvalid={addressInvalid}
				client={client}
				profile={profile}
				applyingJob={applyingJob}
			/>
			{showApplyNow && <div className='d-block d-sm-none' style={{ position: 'fixed', bottom: '0', width: '100%', marginLeft: '-12px', zIndex: 999 }}>
				{!isApplied ? (
					<Button
						className={`text-white fw-bold btn-no-border py-3 ${styles.block_on_mobile}`}
						size='lg'
						onClick={checkIsRequiredICMS}
					>
						<FontAwesomeIcon icon={faPaperPlane} /> &nbsp;&nbsp;
						{t('job_descrip.apply')} Now
					</Button>
				) : (
					<Button
						// disabled={true}
						variant='primary'
						className={`btn-no-border text-white py-3 ${styles.block_on_mobile}`}
					>
						{/* {t('job_list.Applied')} */}
						<FontAwesomeIcon icon={faCheckCircle} /> &nbsp;
						You&apos;ve applied to this jobs
					</Button>
				)}
			</div>}
		</>
	)
}

export default JobDetails